import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.dialogs)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogs, (dialog, index) => {
      return (_openBlock(), _createBlock(_component_Dialog, {
        key: dialog.id,
        class: _normalizeClass([
        _ctx.$style.dialog,
        _ctx.hiddenDialogs.includes(dialog.id) && _ctx.$style.hidden,
      ]),
        component: dialog.component,
        payload: dialog.payload,
        params: dialog.params,
        title: dialog.title,
        "is-closeable": dialog.isCloseable,
        "is-current": index === (_ctx.dialogs.length - 1) && !_ctx.hiddenDialogs.includes(dialog.id),
        onClose: ($event: any) => (_ctx.closeDialogById(String(dialog.id))),
        onHide: ($event: any) => (_ctx.hideDialogById(String(dialog.id)))
      }, null, 8, ["class", "component", "payload", "params", "title", "is-closeable", "is-current", "onClose", "onHide"]))
    }), 128))
  ], 2))
}